export const EnglishRoutes = {
  Home: {
    URL: 'us',
  },
  Register: {
    URL: 'us/register',
  },
  RegisterWithPromotion: {
    URL: 'us/register/:promotion',
  },
  Login: {
    URL: 'us/login',
  },
  Contact: {
    URL: 'us/contact',
  },
  TermsOfUse: {
    URL: 'us/terms',
  },
  Cookies: {
    URL: 'us/cookies',
  },
  Privacy: {
    URL: 'us/privacy',
  },
  Hiring: {
    URL: 'us/contracting-policy',
  },
  HiringWithRate: {
    URL: 'us/contracting-policy/:rate',
  },
  'android-login': {
    URL: 'us/android-login',
  },
  'android-register': {
    URL: 'us/android-register',
  },
  Platform: {
    URL: 'platform',
  },
};
